import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mainMenuArea" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "navTitle" }, " 承影 ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "首页", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "用户", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "项目", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "工具生成日志", -1)

import { useStore } from 'vuex';
import { UserGetters, UserActions } from '@/store/modules/user';
import { ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import {
    ElementPlus,
    Stamp,
    Edit,
    MilkTea
} from '@element-plus/icons-vue';


import { defineComponent } from 'vue';

const __default__ = defineComponent({
    name: "MainMenu",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();
const route = useRoute();
const isCollapse = ref(true);
const selected = computed(() => {
    return route.path === '/' ? route.path : route.path.split('/')[1];
})

const userinfo = computed(() => {
    return store.getters[`user/${UserGetters.getUserInfo}`];
});

onMounted(async () => {
    await store.dispatch(`user/${UserActions.asyncGetOwnInfo}`, {});
})


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_menu, {
      class: "mainMenu",
      "active-text-color": "#ffd04b",
      "background-color": "#111C33",
      "text-color": "#fff",
      router: "",
      "default-active": _unref(selected)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_menu_item, { index: "/" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(ElementPlus))
              ]),
              _: 1
            }),
            _hoisted_3
          ]),
          _: 1
        }),
        (_unref(userinfo) !== null && _unref(userinfo).priv !== 1)
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 0,
              index: "/user"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Stamp))
                  ]),
                  _: 1
                }),
                _hoisted_4
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_menu_item, { index: "/project" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Edit))
              ]),
              _: 1
            }),
            _hoisted_5
          ]),
          _: 1
        }),
        (_unref(userinfo) !== null && _unref(userinfo).priv !== 1)
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 1,
              index: "/generatorLog"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(MilkTea))
                  ]),
                  _: 1
                }),
                _hoisted_6
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["default-active"])
  ]))
}
}

})